
export function formatSalaryRange(minSalary:number, maxSalary:number) {

    if (minSalary === 0 && maxSalary === 0) {
      return "Non paid";
    } else if (minSalary === maxSalary && maxSalary >= 1000) {
      return `${Math.floor(maxSalary / 1000)}K`;
    } else if (minSalary === maxSalary && maxSalary < 1000) {
      return String(maxSalary);
    } else {
      const minStr = minSalary >= 1000 ? `${Math.floor(minSalary / 1000)}` : String(minSalary);
      const maxStr = maxSalary >= 1000 ? `${Math.floor(maxSalary / 1000)}K` : String(maxSalary);
      return `${minStr} - ${maxStr}`;
    }
  }